import { Box, Checkbox } from '@ff-it/ui';
import { OptionProps, components } from 'react-select';
import { ReactElement } from 'react';

export function CheckboxOption({ children, isSelected, ...rest }: OptionProps<any, any, any>): ReactElement {
  return (
    <components.Option {...rest} isSelected={false}>
      <Box display="flex" alignItems="center" gap="2">
        <Checkbox checked={isSelected} readOnly />
        {children}
      </Box>
    </components.Option>
  );
}
